import { render, staticRenderFns } from "./ChosenButton.vue?vue&type=template&id=0086ccce"
import script from "./ChosenButton.vue?vue&type=script&lang=js"
export * from "./ChosenButton.vue?vue&type=script&lang=js"
import style0 from "./ChosenButton.vue?vue&type=style&index=0&id=0086ccce&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports